import DealProfileContainerModal from './DealProfileContainerModal'

export default DealProfileContainerModal
